export default "__VITE_ASSET__DCU$mrPH__"